import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL

class PolicyApi {
  addPolicy(data, config) {
    return axios.post(`${baseUrl}/policy/add`, data, config)
  }

  updatePolicy(id, data, config) {
    return axios.put(`${baseUrl}/policy/${id}`, data, config)
  }

  deletePolicy(id) {
    return axios.delete(`${baseUrl}/policy/${id}`)
  }

  getPolicy() {
    return axios.get(`${baseUrl}/policy/all`)
  }

   searchPolicy(query) {
    return axios.get(`${baseUrl}/policy/search`, { params: { q: query } })
  }
}

export default new PolicyApi()
